import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useMember } from "@/components/MemberProvider";
import { errMsg } from "@/lib/api";

export const NoteDialog = ({ horse, open, onOpenChange }) => {
  const { notes, saveNote } = useMember();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setText(notes[horse] || ""); }, [open, horse, notes]);

  const save = async () => {
    setBusy(true);
    try { await saveNote(horse, text); toast.success("Note saved"); onOpenChange(false); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#131C31] border-white/10" data-testid="note-dialog">
        <DialogHeader><DialogTitle className="font-display">Notes — {horse}</DialogTitle></DialogHeader>
        <Textarea data-testid="note-textarea" rows={6} value={text} onChange={(e) => setText(e.target.value)}
          placeholder="e.g. Wants it wet, settle back, look for 1400m+" className="bg-[#0B101D]" />
        <Button data-testid="note-save-button" onClick={save} disabled={busy} className="bg-blue-600 hover:bg-blue-500">
          {busy ? "Saving…" : "Save note"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
